import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import LocationDistance from "./LocationDistance.js";
/* empty css                      */
function LocationDistanceContainer({ distance, labels = {}, ...rest }) {
  const { getLabel, getFormattedLabel } = useIntl();
  const defaultLabels = React.useMemo(
    () => ({
      distance: getFormattedLabel("stores.location.distance", {
        labelData: { distance: distance || "" }
      }),
      driving: getLabel("stores.location.drivingTime"),
      walking: getLabel("stores.location.walkingTime"),
      ...labels
    }),
    [distance, labels, getFormattedLabel, getLabel]
  );
  return /* @__PURE__ */ React.createElement(LocationDistance, { distance, labels: defaultLabels, ...rest });
}
const LocationDistanceContainer$1 = React.memo(LocationDistanceContainer);
export {
  LocationDistanceContainer$1 as default
};
//# sourceMappingURL=LocationDistanceContainer.js.map
